<div class="page-layout blank fullwidth p-12"  style="height: 1px; overflow-y: scroll; padding: 0 !important;   top: 1px;z-index: 99999;">
  <div class="container">
      <div class="header-bar">
          <div class="header">
          <button class="back-btn" (click)="back()">
              <span>&larr;</span>
          </button>
          <div class="header-text">
              <h2>Redeem Now</h2>
              <p>Garage Essentials</p>
          </div>
          </div>
          <div class="cart-container">
            <button class="back-btn cart" (click)="cart()">🛒</button>
            <span class="cart-count" id="cartCount">0</span>
          </div>

      </div>


      <div class="wallet-redeem">
    <div class="wallet-left">
      <div class="wallet-info">
          <div class="wallet">
      <span class="wallet-icon">💰</span>
        <h3>Wallet: ₹{{walletAmount}}</h3>
        </div>
        <div class="wallet-tags">
          <span class="tag gem">💎 1 point = ₹1</span>
          <span class="tag right">✅ Eligible</span>
        </div>
        <div class="progress-bar">
          <div class="progress"></div>
        </div>
        <p class="wallet-note">No limit • Instant redemption</p>
      </div>
    </div>
    <!-- <div class="wallet-right">
      <button class="redeem-btn">Redeem All</button>
    </div> -->
      </div>

      <div class="wallet-redeem">
    <div class="promo-left">
      <span class="live-now">🔥 LIVE NOW</span>
      <h2 class="promo-title">Redeem Days</h2>
      <p class="promo-subtitle">
        Turn wallet into garage must-haves. No limits. Instant redemption.
      </p>

      <div class="promo-tags">
        <span class="tag">⚡ Instant Apply</span>
        <!-- <span class="tag">🚚 Free Delivery ₹2499+</span> -->
        <span class="tag">✨ 100% Genuine</span>
      </div>
    </div>

    <div class="promo-right">
      <button class="promo-btn">💼 Wallet → Rewards</button>
    </div>
  </div>




  <div class="items">
    <div>
      <div class="sidebar">
    <h3>Categories</h3>

    <div class="category-list">
      <div 
        *ngFor="let category of categories" 
        (click)="selectCategory(category.categoryName)"
        [class.active]="category.isActive"
        class="category-item"
      >
        <div class="icon"><img [src]="category.CategoryImg"></div>
        <div class="label">{{ category.categoryName }}</div>
      </div>
    </div>
      </div>
      </div>
<div class="subcategory-scroll-container-main-div" >
  <div class="subcategory-scroll-container" *ngIf="selectedSubCategories?.length>0">
  <button class="scroll-button left" (click)="scrollLeft()">‹</button>

  <div class="subcategory-pills" #scrollContainer>
    <div 
      class="pill" 
      *ngFor="let sub of selectedSubCategories" 
      [class.selected]="isSelected(sub)"
      (click)="toggleSubCategory(sub)">
      {{ sub }}
    </div>
  </div>
<div>
  <button class="scroll-button right" (click)="scrollRight()">›</button>
  </div>
</div>

      <div class="product-grid">
      <div class="product-card" *ngFor="let product of products">

          <div class="product-title"><img [src]="product.imageUrl" alt="../../../../assets/images/logos/logo.png" onerror="this.src='../../../../assets/images/logos/logo.png'">
          </div>

              <p class="brand">{{ product.brand.name }}</p>
          <div class="product-details">
          <div class="name">{{ product.name }}</div>
          <div class="part">{{ product.partNumber }}</div>
          <!-- <div class="type">{{ product.partType }}</div> -->
          <div class="dimand">
          <div class="price">
              ₹{{ product.mrp }}
          </div>
          <div class="dim-price">💎 {{ product.mrp}}</div>
          </div>
          <div class="badges">
              <span class="badge">✅ Genuine</span>
              <span class="badge">🚚 {{ product.deliveryTime.replace('Delivered in ', '') }}</span>
          </div>

          <div class="buttons">
    <ng-container *ngIf="(cartList.length<=0 || !cartList[0][product.key]) else quantityControls">
      <button class="redeem-item" (click)="redeemProduct(product, 1)">Redeem</button>
    </ng-container>

    <ng-template #quantityControls>
      <div class="quantity-controls redeem-item">
        <button (click)="removeItem(cartList[0][product.key].cart_qty, product.key)">−</button>
        <span>{{ cartList[0][product.key].cart_qty }}</span>
        <button  (click)="addItem(cartList[0][product.key].cart_qty, product.key)">+</button>
      </div>
    </ng-template>
  </div>

          </div>
      </div>
      </div>
  </div>
  </div>


  </div>
</div>